import { Link } from "react-router-dom";
import { Type } from "@shared/ui/Type";

export function SignupAdditionalContent() {
  return (
    <div className="flex flex-col mt-8 gap-4">
      <Type variant="caption">
        Already have an account?{" "}
        <Link
          to="/login"
          className="underline hover:text-brand-600 transition-color duration-200"
        >
          Log in
        </Link>
      </Type>
      <Type variant="caption">
        By signing up, you agree to our{" "}
        <a
          href="/terms"
          target="_blank"
          className="underline hover:text-brand-600 transition-color duration-200"
        >
          Terms of Service
        </a>{" "}
        and{" "}
        <a
          href="/privacy"
          target="_blank"
          className="underline hover:text-brand-600 transition-color duration-200"
        >
          Privacy Policy
        </a>
      </Type>
    </div>
  );
}

export default SignupAdditionalContent;
